var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50004 9.58339L7.16671 11.2501L10.9167 7.50006M14.6667 10.0001C14.6667 14.0904 10.2051 17.0654 8.5817 18.0125C8.39721 18.1201 8.30496 18.1739 8.17477 18.2018C8.07374 18.2235 7.92634 18.2235 7.82531 18.2018C7.69512 18.1739 7.60287 18.1201 7.41838 18.0125C5.79501 17.0654 1.33337 14.0904 1.33337 10.0001V6.01472C1.33337 5.34846 1.33337 5.01533 1.44234 4.72898C1.5386 4.47601 1.69503 4.25029 1.89809 4.07133C2.12795 3.86875 2.43987 3.75178 3.06371 3.51785L7.53188 1.84228C7.70512 1.77732 7.79175 1.74483 7.88086 1.73196C7.9599 1.72053 8.04018 1.72053 8.11922 1.73196C8.20834 1.74483 8.29496 1.77732 8.4682 1.84228L12.9364 3.51785C13.5602 3.75178 13.8721 3.86875 14.102 4.07133C14.3051 4.25029 14.4615 4.47601 14.5577 4.72898C14.6667 5.01533 14.6667 5.34846 14.6667 6.01472V10.0001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.dfe75df3d0afaddec8d98d86edfbc6e5.svg";
export { ForwardRef as ReactComponent };